/* src/components/Portfolio.jsx */
import React from "react"
import PortfolioSlider from "./PortfolioSlider"
import SEO from "./SEO.jsx"

export default function Portfolio() {
  return (
    <section className="bg-gray-50 min-h-screen pt-20 pb-32 px-4 sm:px-6">
      <SEO
        title="Clients | 2merative Web Design"
        description="It is our pleasure to partner with small to medium businesses to build and improve their online presence, including website delivery and Google Business Profile support."
        path="/portfolio"
        image="/og-image.png"
      />
      <PortfolioSlider />
    </section>
  )
}
